import type { Action, LegalAction, PlayerId } from './types';

export type IllegalActionPayload = {
  playerId: PlayerId;
  attempted: Action;
  legalActions: ReadonlyArray<LegalAction>;
  reason: string;
};

/**
 * Thrown by the reducer when an action violates the current rules.
 * Carries structured context so callers can surface a helpful error
 * to the UI, LLM, or bot harness.
 */
export class IllegalActionError extends Error {
  readonly playerId: PlayerId;
  readonly attempted: Action;
  readonly legalActions: ReadonlyArray<LegalAction>;
  readonly reason: string;

  constructor(payload: IllegalActionPayload) {
    super(`IllegalActionError: ${payload.reason} (player=${payload.playerId})`);
    this.name = 'IllegalActionError';
    this.playerId = payload.playerId;
    this.attempted = payload.attempted;
    this.legalActions = payload.legalActions;
    this.reason = payload.reason;
  }
}
